import { render, staticRenderFns } from "./YellowStrip.vue?vue&type=template&id=57535714&scoped=true&lang=pug&"
import script from "./YellowStrip.vue?vue&type=script&lang=js&"
export * from "./YellowStrip.vue?vue&type=script&lang=js&"
import style0 from "./YellowStrip.vue?vue&type=style&index=0&id=57535714&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57535714",
  null
  
)

export default component.exports